import { z } from "zod";

const matchTeamRoles = ["home", "away", "participating"] as const;

export const createMatchSchema = z.object({
  event_court_id: z.string().min(1).nullish(),
  event_venue_id: z.string().min(1).nullish(), // 100
  sport_id: z.string().min(1).nullish(),
  name: z.string().min(1, "Name is required").max(200),
  starts_at: z.string().min(1, "Start time is required"),
  age_group: z.string().max(50).optional(),
  referee: z.string().max(100).optional(),
  first_half_mins: z.number().int().min(1).max(120).optional().default(25),
  break_mins: z.number().int().min(0).max(60).optional().default(5),
  second_half_mins: z.number().int().min(1).max(120).optional().default(25),
});

export const updateMatchSchema = z.object({
  event_court_id: z.string().min(1).nullable().optional(),
  event_venue_id: z.string().min(1).nullable().optional(), // 100
  sport_id: z.string().min(1).nullable().optional(),
  name: z.string().min(1, "Name is required").max(200).optional(),
  starts_at: z.string().min(1).optional(),
  age_group: z.string().max(50).nullable().optional(),
  referee: z.string().max(100).nullable().optional(),
  first_half_mins: z.number().int().min(1).max(120).optional(),
  break_mins: z.number().int().min(0).max(60).optional(),
  second_half_mins: z.number().int().min(1).max(120).optional(),
});

export const addMatchTeamSchema = z.object({
  team_id: z.string().min(1, "Team is required"),
  role: z.enum(matchTeamRoles, { message: "Invalid role" }),
});

// 193 -- bulk shift (POST /events/:eventId/matches/shift). One endpoint, two
// selectors: shift everything from a time point (optionally one court), or an
// explicit selection. delta bounded to +/- 24h, nonzero. `.strict()` so a body
// carrying both selectors is rejected rather than silently picking one.
const shiftDeltaMins = z
  .number()
  .int()
  .min(-1440)
  .max(1440)
  .refine((v) => v !== 0, { message: "delta_mins must be nonzero" });

export const shiftMatchesSchema = z.union([
  z
    .object({
      delta_mins: shiftDeltaMins,
      from: z.string().min(1, "from is required"),
      event_court_id: z.string().min(1).optional(),
    })
    .strict(),
  z
    .object({
      delta_mins: shiftDeltaMins,
      match_ids: z.array(z.string().min(1)).min(1, "match_ids must not be empty").max(500),
    })
    .strict(),
]);

export type CreateMatchInput = z.infer<typeof createMatchSchema>;
export type UpdateMatchInput = z.infer<typeof updateMatchSchema>;
export type AddMatchTeamInput = z.infer<typeof addMatchTeamSchema>;
export type ShiftMatchesInput = z.infer<typeof shiftMatchesSchema>;
